import React, {useEffect} from "react"
import Card from "@material-ui/core/Card"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import { makeStyles, withStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
  root: {
    textAlign: "center",
    width: "100%",
    minHeight: 500,
    padding: 20,
    borderRadius: 20,
    paddingLeft: 30,
    paddingRight: 30,
    boxShadow: "none",
    "@media (max-width: 720px)": {
      width: "100%",
      paddingLeft: 0,
      paddingRight: 0,
      display: "flex",
      justifyContent: "center",
    },
  },
  Logo: {
    maxHeight: 100,
    maxWidth: 180,
  },
  title: {
    color: "#003CAE",
    fontSize: 35,
    marginBottom: 10,
  },
  bodyOfText: {
    color: "#959595",
    fontSize: 17,
  },
  TextInput: {
    width: "100%",
  },
  Link: {
    fontSize: 15,
    display: "flex",
    alignItems: "center",
  },
  LinkIcon: {
    marginRight: 5,
  },
  centeredButton: {
    display: "flex",
    justifyContent: "center",
  },
  mainButton: {
    backgroundColor: "#009FAE",
    borderRadius: 20,
    textTransform: "none",
    fontWeight: 600,
    marginTop: 30,
    width: 100,
    fontSize: 12,
  },
  contentCenter: {
    "@media (max-width: 720px)": {
      display: "flex",
      justifyContent: "center",
    },
  },
})

const StyledButtonSig = withStyles({
  root: {
    background: "linear-gradient(90deg, #CFF31B 0%, #16B1CB 100%)",
    borderRadius: "27px",
    border: 0,
    color: "white",
    height: 48,
    width: "194px",
    padding: "0 30px",
    boxShadow: "0px 3px 6px #0000006A",
  },
  label: {
    textTransform: "none",
    fontFamily: "Helvetica",
    fontSize: "27px",
    font: "800 22px/27px Montserrat",
  },
})(Button)

const finishedBuy = () =>{
  window.location="https://dashboard.masterbotn035.com/"
}

function CustomCard(props) {
  const classes = useStyles()
  const { onCloseModal, ChangePage } = props

  
  return (
    <Card className={classes.root}>
      <Grid container className={classes.contentCenter}>
        <Grid
          xs={8}
          md={12}
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <p className={classes.bodyOfText}>
            Te llegará un correo con los datos para ingresar a la plataforma, es
            importante que revises si <br /> el correo no fue enviado a la
            carpeta de spam. Para cualquier pregunta no dudes en <br />{" "}
            contactarnos.
          </p>
        </Grid>
        <Grid item xs={12} className={classes.centeredButton}>
          <StyledButtonSig
            onClick={onCloseModal}
            className={classes.mainButton}
            onClick={() => finishedBuy()}
            id="COMPRA 4"
          >
            Finalizar
          </StyledButtonSig>
        </Grid>
      </Grid>
    </Card>
  )
}

export default CustomCard

